import React from "react";
import { translate } from "../../services/Translations/translatorService.tsx";
import executionJobStatusChipStyles from "./executionJobStatusChipStyles.ts";
import { Chip } from "@mui/material";
import { ExecutionJob } from "../../types/ExecutionJob/ExecutionJob.ts";

type ExecutionJobStatusChipProps = {
  executionJob: ExecutionJob;
};

export default function ExecutionJobStatusChip({ executionJob }: ExecutionJobStatusChipProps) {
  return (
    <Chip
      size={"small"}
      label={translate(`executionJob.status.${executionJob.status}`, executionJob.status)}
      sx={executionJobStatusChipStyles.jobStatusChipSxByStatus[executionJob.status]}
    />
  );
};
